import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteEmailSequence as DeleteEmailSequenceMutation,
    DeleteEmailSequenceVariables,
    EmailSequenceDeleteInput,
} from 'nutshell-graphql-types';

import DELETE_EMAIL_SEQUENCE from '../../../../../email/mailbox/graphql/mutations/delete-email-sequence.graphql';

export const useCancelManuallyStartedEmailSequence = (): {
    cancelManuallyStartedEmailSequence: (arg1: EmailSequenceDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [cancelManuallyStartedEmailSequence, {loading, error}] = useMutation<
        DeleteEmailSequenceMutation,
        DeleteEmailSequenceVariables
    >(DELETE_EMAIL_SEQUENCE);

    return {
        cancelManuallyStartedEmailSequence: (input: EmailSequenceDeleteInput) =>
            cancelManuallyStartedEmailSequence({variables: {payload: input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
